export enum SnAlarmStatus {
  Open = 'Open',
  Acked = 'Acked',
  Closed = 'Closed',
}
